import InputButton from 'Components/UI/Organisms/Plant/Stock/PaperDevolution/DialogDevolution/InputButton'
import { ESTADO, SUCURSAL_ORIGEN } from 'Constants'

export const Fields = (info, handleSubmitCode, handleChange, isLoading) => {
  return [
    {
      label: 'Origen',
      name: 'empresa',
      options: SUCURSAL_ORIGEN,
      optionLabel: `options["label"]`,
      optionValue: 'id',
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      value: info.empresa,
      onChange: (e) => handleChange('empresa', e.id),
    },
    {
      class: 'custom', //ob
      name: 'search',
      component: (
        <InputButton
          placeholder="CUIT/CUIL/DNI O NOMBRE"
          name="search"
          onSubmit={() => handleSubmitCode(info)}
          onKeyUp={(e) => handleChange('search', e.target.value)}
          value={info.search}
          resetFormDisabled
          loading={isLoading}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      label: 'DNI/CUIT/CUIL',
      name: 'cuit',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.cuit,
    },
    {
      label: 'Razón social',
      name: 'nombre',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.nombre,
    },
    {
      label: 'Estado',
      name: 'estado',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.estado != null ? ESTADO.find((e) => e.value === Number(info.estado))?.label : '',
    },
  ]
}
